
import { useState } from "react";
import { ChevronRight, ArrowDown, FileText, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FeatureComparisonTable } from "./FeatureComparisonTable";

export function EnterprisePlan() {
  const [showForm, setShowForm] = useState(false);

  const scrollToFeatures = () => {
    const featuresTable = document.querySelector('#features-comparison');
    if (featuresTable) {
      featuresTable.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="mt-12 max-w-3xl mx-auto">
      {!showForm ? (
        <>
          <div 
            onClick={() => setShowForm(true)}
            className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow cursor-pointer"
          >
            <div className="flex items-center justify-between group">
              <div className="flex items-center gap-4">
                <div className="h-10 w-10 rounded-full bg-blue-50 flex items-center justify-center">
                  <FileText className="h-5 w-5 text-blue-600" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-1">Educators, Courses, Departments</h3>
                  <p className="text-sm text-gray-600">Custom pricing and features for educational institutions</p>
                </div>
              </div>
              <ChevronRight className="h-5 w-5 text-gray-400 group-hover:text-gray-600 transition-colors" />
            </div>
          </div>

          <div className="flex justify-center mt-6 mb-8">
            <Button
              variant="outline"
              onClick={scrollToFeatures}
              className="text-gray-600 hover:text-gray-900"
            >
              Compare All Features
              <ArrowDown className="ml-1 h-4 w-4" />
            </Button>
          </div>
          
          <FeatureComparisonTable />
        </>
      ) : (
        <div className="space-y-6">
          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setShowForm(false)}
              className="text-gray-600 hover:text-gray-900"
            >
              <ArrowLeft className="mr-1 h-4 w-4" />
              Back to Features
            </Button>
          </div>
          
          <iframe
            src="https://tally.so/embed/n0Z2o0?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
            width="100%"
            height="800"
            frameBorder="0"
            marginHeight={0}
            marginWidth={0}
            title="Enterprise Pricing Form"
            className="mx-auto w-full max-w-3xl"
          />
        </div>
      )}
    </div>
  );
}
